import * as React from "react";
import "./styles.scss";
import {partnerOfferings} from "login/config";


interface IProps {
    partner?: string;
}

function Footer(props: IProps) {
    return (
        <footer className={`${document.body.scrollHeight > screen.height ? "footer" : "fixed-footer"} ${(props.partner && partnerOfferings.hasOwnProperty(props.partner)) ? `${props?.partner?.toLowerCase()}-footer` : ""} py-3`} id="app-footer">
            <div className="container footer-wrapper">
            <span className="text-muted1">© {new Date().getFullYear()} MyShubhLife. All Rights Reserved.</span>
            {
               props.partner && partnerOfferings.hasOwnProperty(props.partner) && <span className="text-muted1">{`In partnership with ${partnerOfferings[props.partner].name}`}</span>
            }
            </div>
        </footer>
    );
}
export default Footer;
